export default class EmailRule {
  constructor ({ email_rule_type_id = null, id = null, email_id = null, parameters = {}, target_id = null } = {}) {
    this.email_rule_type_id = email_rule_type_id
    this.id = id
    this.email_id = email_id
    this.parameters = parameters
    this.target_id = target_id
  }

  get to_database () {
    return {
      email_rule_type_id: this.email_rule_type_id,
      parameters: this.parameters,
      target_id: this.target_id
    }
  }
}
